<template>
  <section class="w-full">
    <Intersect
      v-editable="blok"
      :threshold="0.5"
      @enter.once="handleVisibility"
    >
      <CMSLink
        :cms-link="blok.ctaLink"
        class="flex flex-col gap-2 hover:cursor-pointer"
        @click="trackingMethod"
      >
        <div
          class="relative mb-[16px] h-auto w-full overflow-hidden sm:mb-[25px]"
          @mouseenter="toggleButton"
          @mouseleave="toggleButton"
        >
          <AssetImage
            v-if="blok.Image && blok.Image[0]"
            :blok="blok.Image[0]"
            :optimise-desktop="optimiseDesktop"
          />

          <Transition v-if="blok.ctaLabel" name="SlideBottomFade">
            <div
              v-if="showButton"
              class="absolute inset-x-0 bottom-0 block w-full p-3"
            >
              <button
                class="relative block w-full break-words bg-white/80 px-6 py-7 text-sm font-medium shadow-button"
              >
                {{ blok.ctaLabel }}
              </button>
            </div>
          </Transition>
        </div>

        <h2
          class="mb-[5px] text-lg font-medium leading-[24px] sm:mb-[9px] sm:text-xl sm:leading-[32px]"
        >
          {{ blok.headline }}
        </h2>
        <p
          class="text-base font-normal leading-[19px] sm:text-lg sm:leading-[24px]"
        >
          {{ blok.textArea }}
        </p>
      </CMSLink>
    </Intersect>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type { SbImageText } from '~/cms/storyblok/types/storyblok.d.ts'

type ImageTextProps = {
  blok?: SbImageText
  trackingAction?: () => void
  optimiseDesktop?: boolean
  index?: string
}

const props = withDefaults(defineProps<ImageTextProps>(), {
  blok: () => ({}) as SbImageText,
  trackingAction: undefined,
  optimiseDesktop: true,
  index: '1',
})

const { trackPromotionSelect, trackPromotionView } = useTrackingEvents()
const showButton = ref<boolean>(false)

function toggleButton(): void {
  showButton.value = !showButton.value
}

const trackingMethod = () =>
  props.trackingAction
    ? props.trackingAction()
    : trackPromotionSelect({
        id: props.blok.promotion_id || 'image_text_promotion_id',
        name: props.blok.promotion_name || 'image_text_promotion_name',
        promoType: 'imagetext',
        position: Number(props.index) + 1,
        creativeNameSb: props.blok.creative_name || '',
      })

const handleVisibility = () => {
  if (props.trackingAction !== undefined) {
    return
  }
  trackPromotionView({
    id: props.blok.promotion_id || 'image_text_promotion_id',
    name: props.blok.promotion_name || 'image_text_promotion_name',
    promoType: 'imagetext',
    position: Number(props.index) + 1,
    creativeNameSb: props.blok.creative_name || '',
  })
}
</script>
